import { BundleConfig } from 'modules/billing/pages/BundlesHomepage/types'

import PeriodSelector from '..'

type Props = {
  configPlan: BundleConfig
  setConfigPlan: React.Dispatch<React.SetStateAction<BundleConfig>>
}

const PeriodSelectorConfigPlan = ({ configPlan, setConfigPlan }: Props) => (
  <PeriodSelector
    onChange={(newPeriod) => setConfigPlan({ ...configPlan, period: newPeriod })}
    currentPeriod={configPlan.period}
  />
)

export default PeriodSelectorConfigPlan
